import { Range } from "immutable";

import { getAPI, getAllAPI, deleteAPI } from "./api";
import { handleError, apiRequest } from "../lib/utils/request";
import { ValidationError } from "../../common/lib/validation";
import { setField } from "../../common/lib/redux-fields/actions";

export const GET_APPLICATIONS = "GET_APPLICATIONS";
export const GET_APPLICATIONS_SUCCESS = "GET_APPLICATIONS_SUCCESS";
export const GET_APPLICATIONS_ERROR = "GET_APPLICATIONS_ERROR";
export const GET_APPLICATIONS_FINALLY = "GET_APPLICATIONS_FINALLY";

export const GET_APPLICATION = "GET_APPLICATION";
export const GET_APPLICATION_SUCCESS = "GET_APPLICATION_SUCCESS";
export const GET_APPLICATION_ERROR = "GET_APPLICATION_ERROR";
export const GET_APPLICATION_FINALLY = "GET_APPLICATION_FINALLY";

export const DELETE_APPLICATION = "DELETE_APPLICATION";
export const DELETE_APPLICATION_SUCCESS = "DELETE_APPLICATION_SUCCESS";
export const DELETE_APPLICATION_ERROR = "DELETE_APPLICATION_ERROR";
export const DELETE_APPLICATION_FINALLY = "DELETE_APPLICATION_FINALLY";

export const SET_APPLICATION_PAGE = "SET_APPLICATION_PAGE";
export const SET_APPLICATION_SORT = "SET_APPLICATION_SORT";

export const APPLICATION_CLEAR_ERROR = "APPLICATION_CLEAR_ERROR";
export const APPLICATION_CLEAR_FORM = "APPLICATION_CLEAR_FORM";

export const SET_DELETE_STATUS = "SET_DELETE_STATUS";

export const getAll = () => async (dispatch, getState, utils) => {
  const data = getState().application.meta.toJS();

  const action = GET_APPLICATIONS;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAllAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const get = data => async (dispatch, getState, utils) => {
  const action = GET_APPLICATION;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const deleteOne = data => async (dispatch, getState, utils) => {
  const action = DELETE_APPLICATION;
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      deleteAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );

    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const setPage = page => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_APPLICATION_PAGE,
    payload: { page }
  });

  dispatch(getAll());
};

export const setSort = (field, dir) => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_APPLICATION_PAGE,
    payload: { page: 1 }
  });

  dispatch({
    type: SET_APPLICATION_SORT,
    payload: { field, dir }
  });

  dispatch(getAll());
};

export const setDeleteStatus = status => ({
  type: SET_DELETE_STATUS,
  payload: { status }
});



// WEBPACK FOOTER //
// ./src/common/application/actions.js